module.exports = __webpack_public_path__ + "img/sure-hero-desktop.4195e16a.svg";